import { render, staticRenderFns } from "./AddVip.vue?vue&type=template&id=709750d8&scoped=true"
import script from "./AddVip.vue?vue&type=script&lang=js"
export * from "./AddVip.vue?vue&type=script&lang=js"
import style0 from "./AddVip.vue?vue&type=style&index=0&id=709750d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709750d8",
  null
  
)

export default component.exports